import { BrandsDto } from '@texas/api/endpoints/customersApi';
import { SignalDispatcher } from 'ste-signals';
import { SimpleEventDispatcher } from 'ste-simple-events';

export const angularEvents = {
  newBrandCreated: new SimpleEventDispatcher<BrandsDto>(),
  articleManagementUpdated: new SignalDispatcher(),
  addSupplierClicked: new SimpleEventDispatcher<{
    variantId: number;
    branchId: number;
    branchName: string;
  }>(),
};
